import { styled } from "@mui/material/styles";
import { OutlinedInput } from "@mui/material";

const MyTextField = styled(OutlinedInput)(({ theme }) => ({
  backgroundColor: "transparent",
  border: "0.5px solid #F8F7F999",
  fontFamily: "Plus Jakarta Sans",
  color: "#F8F7F9",
  padding: "20px 1px",
  height: "1.5em",
  marginBottom: "1rem",
  borderRadius: "0",
  fontWeight: 500,
  textAlign: "start",
  width: "100%",
  "label + &": {
    marginTop: theme.spacing(3),
    fontFamily: "Plus Jakarta Sans",
    color: "#F8F7F9",
  },
  "label.Mui-focused + &": {
    color: "#F8F7F9",
  },
  "&:hover fieldset.MuiOutlinedInput-notchedOutline": {
    borderColor: "#F8F7F999",
  },
  "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
    borderColor: "#F8F7F999",
  },
}));

export default MyTextField;
